import MapMarkerIcons from './MapMarkerIcons';

/* global google */

/*

model=instance of MapModel
id=<int>, location id
latLng=instance of google.maps.LatLng
type=<string>, location type

*/

function MapMarker(model, id, latLng, type) {
  this.id = id;
  this.model = model;
  this.type = type;
  const markerData = {
    position: latLng,
    zIndex: 1,
  };
  if (this.getIcon(type, 'normal') !== null) {
    markerData.icon = this.getIcon(type, 'normal');
  }
  this.marker = new google.maps.Marker(markerData);
  this.handlers = {
    mouseout: null,
    mouseover: null,
    click: null,
  };
  this.init();
}

MapMarker.prototype = {
  addToMap(mapObject) {
    this.marker.setMap(mapObject);
  },

  init() {
    const obj = this;
    this.handlers.mouseover = google.maps.event.addListener(
      this.marker,
      'mouseover',
      () => {
        obj.model.setLocationActive(obj.id);
      },
    );
    this.handlers.mouseout = google.maps.event.addListener(
      this.marker,
      'mouseout',
      () => {
        obj.model.setLocationInactive(obj.id);
      },
    );

    this.handlers.click = google.maps.event.addListener(
      this.marker,
      'click',
      () => {
        if (obj.model.getSelectedLocation() !== obj.id) {
          obj.model.selectLocation(obj.id);
        } else {
          obj.model.unselectLocation();
        }
      },
    );
  },

  uninit() {
    google.maps.event.removeListener(this.handlers.mouseover);
    google.maps.event.removeListener(this.handlers.mouseout);
    google.maps.event.removeListener(this.handlers.click);
  },

  /*
      type=string, location / icon type
      state=normal or hover
    */

  getIcon(type, state) {
    if (
      typeof MapMarkerIcons[type] !== 'undefined' &&
      typeof MapMarkerIcons[type][state] !== 'undefined'
    ) {
      return MapMarkerIcons[type][state];
    }
    return null;
  },

  displayActiveState() {
    if (this.getIcon(this.type, 'hover') !== null) {
      this.marker.setIcon(this.getIcon(this.type, 'hover'));
      this.marker.setZIndex(2);
    }
  },

  displayInactiveState() {
    if (this.getIcon(this.type, 'normal') !== null) {
      this.marker.setIcon(this.getIcon(this.type, 'normal'));
      this.marker.setZIndex(1);
    }
  },
};

export default MapMarker;



// WEBPACK FOOTER //
// ./src/js/maps/MapMarker.js